import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n'; // 匯入 i18n 配置
import App from './App';
import reportWebVitals from './reportWebVitals';

if (process.env.REACT_APP_SENTRY_DSN) {
  import('@sentry/react').then(({ init, browserTracingIntegration }) => {
    init({
      dsn: process.env.REACT_APP_SENTRY_DSN,
      environment: process.env.REACT_APP_DEPLOY_ENV || 'dev',
      integrations: [browserTracingIntegration()],
      tracesSampleRate: 0.1,
    });
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// PWA service worker（#24 Phase C2）· shell offline / data online
// [LOW-3] 僅 production 註冊：dev build 的 hashed bundle 被 cache-first serve 會導致 F5 拿到 stale JS/CSS。
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch(() => {
      /* silent ok: SW 註冊失敗不影響一般使用（非 PWA 環境 / 不支援） */
    });
  });
}
